import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
export default function PublicRoute(props) {


  return (
    <>
      {Cookies.get("test_engine_token") ? (
        <Navigate to={`/${Cookies.get("test_engine_project")}/home`} />
      ) : (
        props.children
      )}
    </>
  );
}
